import * as React from "react";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
// import { selectLoader } from "../store";

function Loader({ loading }) {
    //   const { loading } = useSelector(selectLoader);
    return (
        <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999999 }}
            open={loading}
            onClick={() => { }}
        >
            <CircularProgress />
        </Backdrop>
    );
}

export default Loader;